import React from "react";
import { useIsMounted } from "../../../hooks";
export const FreeContentDisplay = ({ scriptContent, }) => {
    const isMounted = useIsMounted();
    return (React.createElement("div", { className: "free-content-display" }, isMounted && (React.createElement("div", { dangerouslySetInnerHTML: { __html: scriptContent } }))));
};
